<template>
    <div class="loginDiv">
        <el-form >
            <fieldset>
                <legend>Sign In</legend>
                <div>
                    <el-form-item>
                        <el-input id="username" v-model="username" size="large" placeholder="Email Address" :prefix-icon="User"/>
                        <span class="error" v-show="!usernameIsOK">Please input your email address</span>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="password" size="large" type="password" placeholder="Password" :prefix-icon="Lock" show-password/>
                        <span class="error" v-show="!passwordIsOK">Please input password (6 - 20 letter or digitals)</span>
                    </el-form-item> 
                    <div style="line-height:35px;">
                        <div class="rememberMe"><el-switch v-model="rememberMe"></el-switch> Keep me signed in</div>
                        <div style="float:right"><router-link to="forgetPassword" class="forget">Forget your password?</router-link></div>
                    </div>
                    <div style="clear:both;"></div>
                    <el-form-item>
                        <el-button type="primary" style="margin-top:10px;margin-right:8px;" class="primary" @click="login">Sign In</el-button>
                        <div class="errMsg" v-if="errMsg != ''" v-html="errMsg"></div>
                    </el-form-item>
                </div>
            </fieldset>
        </el-form>
    </div>
</template>

<script>
import {User, Lock} from '@element-plus/icons-vue'
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            username: '',
            password: '',
            rememberMe: false,
            needCheck: false,
            errMsg: '',
            User, Lock,
            global,
        }
    },
    computed: {
        usernameIsOK: function() {
            let reg = /^([0-9A-Za-z-_.]+)@([0-9a-z-]+\.[a-z]{2,4}(\.[a-z]{2})?)$/g; 
            if (this.needCheck)           
                return this.username != "" && reg.test(this.username)
            return true;
        },
        passwordIsOK: function() {
            if (this.needCheck) 
                return this.password != "" && this.password.length >= 6
            return true;
        }
    },
    methods: {
        async login() {
            this.needCheck = true;
            this.errMsg = "";
            let host = window.location.host;
			if (host.indexOf("premia-partners.com") != -1)
				host = "premia-partners.com";
			else host = null;
            let data = {
                username: this.username,
                password: this.password,
                rememberMe: this.rememberMe
            };
            if (this.usernameIsOK && this.passwordIsOK) {
                let backURL = this.$route.query && this.$route.query.backURL 
                                ? this.$route.query.backURL : null;
                let result = await AXIOS("/login", data);
                if (result.success) {
                    this.global.setCurrentUser(result.data.currentUser);
                    this.global.setToken(result.data.token);
                    this.global.setRights(result.data.rights);
                    this.global.setCookie("sid", result.data.sid, this.rememberMe?7:0, "/", host);
                    if (backURL && backURL.indexOf("http") == 0) 
                        window.location.href = backURL;
                    else
                        this.$router.push(backURL ? backURL : "/")
                } else {
                    this.errMsg = result.errMsg;
                }
            }
        },
        
    }
}
</script>

<style scoped>
    .loginDiv {
        width:500px;
        margin:100px auto;
    }
    .loginDiv fieldset {
        margin:0px;
        border:1px solid #ddd;
        border-radius: 8px;
        padding:20px 30px;
        background:#fcfcfc;
        box-shadow: rgb(211, 211, 211) 2px 3px 8px 0px;
    }
    .fieldset input {
        font-size:16px;
    }
    .loginDiv legend {
        font-size:28px;
        color:#01b1af;
    }
    .forget {
        color:#01b1af;
        text-decoration: none;
    }
    .forget:hover {
        color:#01b1af;
    }
    .rememberMe {
        float: left;
        color:#999;
    }
    .error {
        color:#F56C6C;
    }
    .errMsg {
        margin-top:10px;
        margin-left:0px;
        line-height:1.4em;
        font-size:13px;
    }
    
</style>
